// src/App.js
import React, { useState } from "react";
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import { Box } from "@chakra-ui/react";
import { AuthProvider } from "./context/AuthContext";
import { ChakraProvider } from "@chakra-ui/react";
import { EnvDataProvider } from "./context/EnvDataContext";
import theme from "./themev";
import SingleDeviceDashboard from "./components/pages/SingleDeviceDashboard";
import Dashboard from "./components/pages/Dashboard";
import Login from "./components/pages/Login";
import DeviceManager from "./components/pages/DeviceManager";
import UserManager from "./components/pages/UserManager";
import CustomerManager from "./components/pages/CustomerManager";
import AllDevicesDashboard from "./components/pages/AllDevicesDashboard";
import MainMenu from './components/pages/MainMenu';
import DeviceHistoryPage from "./components/pages/DeviceHistoryPage";
import { Header } from "./components/Header";


const App = () => {
  const [currentTheme, setCurrentTheme] = useState(theme);

  return (
    <ChakraProvider theme={currentTheme}>
      
      <EnvDataProvider>
      <AuthProvider>
        <Router><Header />
            <Routes>
              <Route path="/" element={<MainMenu />} />
              <Route path="/menu" element={<MainMenu />} />
              <Route path="/dashboard/:deviceId" element={<SingleDeviceDashboard />} />
              <Route path="/login" element={<Login />} />
              <Route path="/customers" element={<CustomerManager />} />
              <Route path="/users" element={<UserManager />} />
              <Route path="/devices" element={<DeviceManager />} />
              <Route path="/console" element={<AllDevicesDashboard />} />
              <Route path="/history" element={<DeviceHistoryPage />} />
            </Routes>
        </Router>
      </AuthProvider>
      </EnvDataProvider>
    </ChakraProvider>
  );
};

export default App;